const ApiGdpr = {
    'body':'',
    'start': function(){
      let self = this
      self.init();
      self.showGdpr();

    },
    'showGdpr': function(){
        let self = this;
        let gdpr = self.body.find('div.gdpr');
        let hasGdpr = localStorage.getItem('gdpr');

        if (hasGdpr == 'confirmed'){
            gdpr.addClass('hidden');
        }else{
            self.setGdpr();
        }
    },
    'setGdpr': function(){
        let self =this;
        let gdpr = self.body.find('div.gdpr');
        let btns = gdpr.find('button');
        btns.on('click', function(){
           let thisClick = $(this);
               localStorage.setItem('gdpr', 'confirmed');
        });
    },
    'init':function(){
        let self = this;
        self.body = $('body');
    }
}

$(document).ready(function(){
    ApiGdpr.start();
});
